/**
 * Indicates the broad product or asset classification. May be used to provide grouping for the product taxonomy (Product(460), SecurityType(167), etc.) and/or the risk taxonomy (AssetClass(1938), AssetSubClass(1939), AssetType(1940), etc.).
 * tag: 2210
 * @readonly
 * @enum {number} (int)
 */
export enum AssetGroup {
  Financials = 1,
  Commodities = 2,
  AlternativeInvestments = 3,
}
